module.exports = __webpack_public_path__ + "static/andrea-befe1c518b24129f3d3b92e2d8f02a86.svg";